<template>
  <div class="app-container">
    <el-container>
      <!-- 左侧导航栏 -->
      <el-aside style="background-color: #f5f7fa; flex: 0 0 auto">
        <!-- 素材库选择按钮 -->
        <div class="library-selector">
          <el-button type="primary" icon="el-icon-folder-opened" @click.stop="showLibrarySelector">
            选择素材库
          </el-button>
        </div>
        <!-- {{ $store.state.selectedLibrary }}
        {{ $store.state.cookile }} -->
        <!-- 素材库列表 -->
        <!--        <el-menu-->
        <!--          :default-active="activeLibrary"-->
        <!--          :default-openeds="['submenu']"-->
        <!--          class="library-menu"-->
        <!--        >-->
        <!--          <el-submenu  index="submenu">-->
        <!--            <template #title>-->
        <!--              <i class="el-icon-folder"></i>-->
        <!--              <span>{{ selectedLibrary.scName || '请选中素材库' }}</span>-->
        <!--              <i class="el-icon-circle-plus" @click.stop="wjjhandleAddClick"></i>-->
        <!--            </template>-->
        <!--            <el-menu-item-->
        <!--              v-for="library in libraries"-->
        <!--              :key="library.id"-->
        <!--              :index="library.id"-->
        <!--              @click="handleFolderClick(library)"-->
        <!--            >-->
        <!--              <i class="el-icon-folder-opened"></i>-->
        <!--              {{ library.name }}-->
        <!--            </el-menu-item>-->
        <!--          </el-submenu>-->
        <!--        </el-menu>-->



        <el-menu :default-active="activeLibrary" :default-openeds="openedMenus" class="hierarchy-menu" ref="menuContainer"
          @select="handleMenuSelect">
          <!-- 一级目录 -->
          <el-submenu index="main">
            <template #title>
              <div class="title-container" style="display: inline-flex; align-items: center;">
                <!-- 只包图标+文本，不包“+” -->
                <span class="title-click" @click="handleFolderClick({ 'id': null })"
                  style="cursor: pointer; display: inline-flex; align-items: center;">
                  <i class="el-icon-folder"></i>
                  <span style="margin: 0 4px;">
                    {{ selectedLibrary.scName || '请选择素材库' }}
                  </span>
                </span>

                <!-- 加号单独出来，阻止冒泡 -->
                <i class="el-icon-circle-plus" @click.stop="wjjhandleAddClick(null)"
                  style="margin-left: 8px; cursor: pointer;"></i>
              </div>
            </template>
            <!-- 二级目录 -->
            <el-submenu v-for="item in secondaryMenus" :key="item.id" :index="`sec_${item.id}`">
              <template #title>
                <div class="submenu-header">
                  <!-- 自定义展开箭头 -->
                  <i class="expand-icon" :class="isSubmenuOpen(item.id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                    @click.stop="toggleSubmenu(item.id)"></i>

                  <!-- 名称点击区域 -->
                  <div class="title-content" @click.stop="handleFolderClick(item)">
                    <i class="el-icon-folder-opened"></i>
                    <span>{{ item.name }}</span>
                  </div>

                  <!-- 添加按钮 -->
                  <i class="el-icon-circle-plus" @click.stop="wjjhandleAddClick(item)"></i>
                </div>
              </template>

              <!-- 三级目录 -->
              <el-menu-item v-for="child in getChildren(item.id)" :key="child.id" :index="child.id"
                @click.stop.native="handleItemClick(child, item.id)">
                <i class="el-icon-document"></i>
                {{ child.name }}
              </el-menu-item>
            </el-submenu>
          </el-submenu>
        </el-menu>

      </el-aside>

      <el-dialog title="新建文件夹" :visible.sync="wjjdialogVisible" width="30%" :modal="false">
        <el-input v-model="newLibraryName" placeholder="请输入文件夹名称" clearable></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="wjjdialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="wjjhandleConfirm">确 定</el-button>
        </span>
      </el-dialog>




      <!-- 右侧内容区 -->
      <el-main>

        <!-- 标签页 -->
        <el-tabs v-model="activeTab" @tab-click="handleTabChange">
          <!-- 图片标签页 -->
          <el-tab-pane label="图片" name="image">
            <div class="action-bar">


              <el-checkbox :indeterminate="isIndeterminateimg" v-model="checkAllimg"
                @change="cheachallimg">全选</el-checkbox>
              <el-button type="primary" icon="el-icon-delete" @click="deleteImg">
                删除图片
              </el-button>
              <el-button type="primary" icon="el-icon-upload" @click="showUploadDialog('image')">
                上传图片
              </el-button>
              <el-button type="primary" icon="el-icon-upload" @click="resetStatu()">
                重置选择
              </el-button>
              <el-button v-if="selectedMaterials.length || VselectedMaterials.length" type="primary" icon="el-icon-check"
                @click="handleAllSelect">
                {{ handletpCardSelect == 0 ? "" : handletpCardSelect }} 确认选中
              </el-button>

              <el-input style="width: 200px; margin-right: 10px;" placeholder="请输入内容" v-model="ImgSCName">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>


              <el-button icon="el-icon-search" circle @click="selectImg()"> </el-button>






            </div>

            <!-- 图片卡片列表 -->
            <div v-loading="loading" class="material-container">

              <el-row class="compact-row" type="flex">
                <el-col v-for="(item, index) in materialList" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                  <div class="col-inner">
                    <el-card class="material-card">
                      <div class="card-checkbox">
                        <el-checkbox v-model="item.checked" @change="handleCardSelect(item)"></el-checkbox>
                      </div>
                      <div class="card-content" @click="handlePreview(item)">
                        <el-image :src="'https://ads-marketing-vivofs.vivo.com.cn/' + item.filePath" fit="cover"
                          class="card-image">
                          <div slot="error" class="image-error">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <div class="card-info">
                          <div class="file-name" :title="item.title">{{ item.title }}</div>
                          <div class="file-size">大小:{{ ((item.fileSize) / 1024).toFixed(2) }}k</div>
                          <div class="file-size">{{ item.width }} *{{ item.height }} </div>
                          <div class="file-time">{{ item.createTime }}</div>
                        </div>
                        <div class="preview-action">
                          <i class="el-icon-view" @click.stop="VhandlePreview(item)"></i>
                        </div>
                      </div>

                    </el-card>
                  </div>
                </el-col>
              </el-row>


              <!-- 分页组件 -->
              <el-pagination background layout="total, sizes, prev, pager, next" :current-page="pageIndex"
                :page-sizes="[52, 100]" :page-size="pageSize" :total="totalCount" @size-change="handleSizeChange"
                @current-change="handlePageChange" style="margin-top: 20px; text-align: center;"></el-pagination>
            </div>
          </el-tab-pane>

          <!-- 视频标签页 -->
          <el-tab-pane label="视频" name="video">
            <div class="action-bar">
              <el-checkbox :indeterminate="isIndeterminatevideo" v-model="checkAllvideo"
                @change="cheachallvideo">全选</el-checkbox>
              <el-button type="primary" icon="el-icon-delete" @click="deleteVideo">
                删除视频
              </el-button>
              <el-button type="primary" icon="el-icon-upload" @click="showvideoUploadDialog()">
                上传视频
              </el-button>
              <!--              <el-button-->
              <!--                type="primary"-->
              <!--                icon="el-icon-upload"-->
              <!--                @click="resetStatu()"-->
              <!--              >-->
              <!--                重置选择-->
              <!--              </el-button>-->
              <el-button v-if="selectedMaterials.length || VselectedMaterials.length" type="primary" icon="el-icon-check"
                @click="handleAllSelect">
                {{ handlespCardSelectnumber == 0 ? "" : handlespCardSelectnumber }} 确认选中
              </el-button>

              <el-input style="width: 200px; margin-right: 10px;" placeholder="请输入内容" v-model="VideoSCName">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>


              <el-button icon="el-icon-search" circle @click="selectVideo()"> </el-button>


            </div>

            <!-- 视频卡片列表 -->
            <div v-loading="loading" class="material-container">
              <el-row class="video-row">
                <el-col class="el-col" v-for="(item, index) in VmaterialList" :key="item.id" :xs="24" :sm="12" :md="8"
                  :lg="6" :xl="4">
                  <div class="video-card-wrapper">
                    <el-card class="material-card">

                      <div class="card-checkbox">
                        <el-checkbox v-model="item.checked" @change="VhandleCardSelect(item)"></el-checkbox>
                      </div>

                      <div class="card-content" @click.stop="checkVideo(item)">
                        <div class="video-wrapper">
                          <el-image :src="item.coverImgFullPath || require('@/assets/logo.png')" fit="cover"
                            class="card-image">
                            <div slot="error" class="image-error">
                              <i class="el-icon-video-camera"></i>
                            </div>
                          </el-image>

                          <!-- 视频时长显示优化 -->
                          <div class="video-duration">
                            {{ formatDuration(item.duration) }}
                          </div>

                          <div class="video-play">
                            <i class="el-icon-video-play"></i>
                          </div>
                        </div>

                        <div class="card-info">


                          <div class="card-info">
                            <div class="file-name" :title="item.title">{{ item.name }}</div>
                            <div class="file-size">{{ formatFileSize(item.fileSize) }}</div>
                            <div class="file-size">{{ item.width }} *{{ item.height }} </div>
                            <div class="file-time">{{ item.title }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="preview-action">
                        <i class="el-icon-view" @click.stop="VhandlePreview(item)"></i>
                      </div>
                    </el-card>
                  </div>
                </el-col>
              </el-row>

              <!-- 分页组件 -->
              <el-pagination background layout="total, sizes, prev, pager, next" :current-page="pageIndex"
                :page-sizes="[52, 100]" :page-size="pageSize" :total="videototalCount"
                @size-change="videohandleSizeChange" @current-change="videohandlePageChange"
                style="margin-top: 20px; text-align: center;"></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-main>

      <!-- 素材库选择对话框 -->
      <el-dialog title="选择素材库" :visible.sync="libraryDialogVisible" width="30%" :modal="false">
        <el-select v-model="selectedLibrary" value-key="id" placeholder="请选择素材库" filterable style="width: 100%">
          <el-option v-for="item in libraryOptions" :key="item.id" :label="item.scName" :value="item" />
        </el-select>
        <span slot="footer">
          <el-button @click="libraryDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="getFolder">确定</el-button>
        </span>
      </el-dialog>

      <!-- 上传对话框 -->
      <el-dialog :title="`上传图片（已选择 ${imgList.length} 张）`" :visible.sync="uploadDialogVisible" width="500px"
        :modal="false">
        <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true" ref="upload"
          :file-list="imgList" :on-change="handleFileChange" :on-success="handleUploadSuccess" :show-file-list="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            支持JPEG/PNG格式
          </div>
        </el-upload>

        <!-- 底部操作按钮 -->
        <template slot="footer">
          <div class="dialog-footer">
            <el-button type="danger" @click="imgReset">重 置</el-button>
            <el-button @click="uploadDialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="uploading" @click="handleConfirmUpload">
              确 定（{{ imgList.length }}）
            </el-button>
          </div>
        </template>
      </el-dialog>

      <!--      上传视频-->
      <el-dialog :title="`上传视频（已选择 ${videoList.length} 个）`" :visible.sync="videouploadDialogVisible" width="500px"
        :modal="false">
        <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true" ref="upload"
          :file-list="videoList" :on-change="videohandleFileChange" :on-success="videohandleUploadSuccess"
          :show-file-list="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            支持MP4格式
          </div>
        </el-upload>

        <!-- 底部操作按钮 -->
        <template slot="footer">
          <div class="dialog-footer">
            <el-button type="danger" @click="videoReset">重 置</el-button>
            <el-button @click="videouploadDialogVisible = false">取 消</el-button>
            <el-button type="primary" :loading="videouploading" @click="videohandleConfirmUpload">
              确 定（{{ videoList.length }}）
            </el-button>
          </div>
        </template>
      </el-dialog>

      <!-- 预览对话框 -->
      <!--      <el-dialog-->
      <!--        :modal="false"-->
      <!--        :visible.sync="previewVisible"-->
      <!--        :title="previewItem.name"-->
      <!--        width="60%"-->
      <!--        top="5vh"-->
      <!--      >-->
      <!--        <img-->
      <!--          v-if="activeTab === 'image'"-->
      <!--          :src="`https://ads-marketing-vivofs.vivo.com.cn/${previewItem.filePath	}`"-->
      <!--          class="preview-image"-->
      <!--          style="height:800px"-->
      <!--        >-->
      <!--   -->
      <!--      </el-dialog>-->


      <el-dialog :key="VpreviewItem.id" :modal="false" :visible.sync="VpreviewVisible" :title="VpreviewItem.title"
        width="60%" top="5vh">
        <img v-if="activeTab === 'image'" :src="getImageUrl(VpreviewItem.previewUrl)" class="preview-image"
          style="width: 100%">
        <video v-else controls :key="VpreviewItem.fileFullPath" class="preview-video" style="height:700px;">
          <source :src="VpreviewItem.fileFullPath" :type="'video/' + VpreviewItem.assetFormat">
          您的浏览器不支持视频播放
        </video>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from '../../bus.js';

export default {

  props: {
    library: {
      type: Object,
      default: () => ({})
    }
  },

  data() {

    return {
      isIndeterminatevideo: false,
      checkAllvideo: false,
      isIndeterminateimg: false,
      checkAllimg: false,

      ImgSCName: '', // 搜索图片素材的名称
      VideoSCName: '', // 搜索视频素材的名称
      imgList: [],
      videoList: [],
      // 分页相关数据
      pageIndex: 1,
      pageSize: 52,
      totalCount: 0,
      videototalCount: 0,
      // 文件夹
      wjjdialogVisible: false,
      newLibraryName: '',
      submitting: false,
      // 素材库相关
      libraries: [
        {
          "id": 1,
          "parentId": null,
          "name": "请先创建文件夹"
        }
      ],
      libraryOptions: [],
      selectedLibrary: null,
      libraryDialogVisible: false,
      activeLibrary: null,
      openedMenus: ['main'], // 存储展开状态的数组
      forceKeepOpen: false,    // 保持展开状态标志
      // 文件夹和素材相关
      activeFolder: null,
      materialList: [],
      selectedMaterials: [],
      VmaterialList: [],
      VselectedMaterials: [],
      loading: false,

      // 标签页相关
      activeTab: 'image',

      // 上传相关
      uploadDialogVisible: false,
      videouploadDialogVisible: false,
      uploadType: 'image',
      uploadUrl: '/api/upload/image',
      acceptType: 'image/*',

      // 预览相关
      previewVisible: false,
      previewItem: {},
      VpreviewVisible: false,
      VpreviewItem: {},
      zjcookie: '',
      fjcookie: '',
      uploading: false,  // 上传状态
      videouploading: false,  // 上传状态
      beSelectFold: {},
      handlespCardSelectnumber: 0,
      handletpCardSelect: 0,
      ddname: "",
      previewList: []
    }
  },


  created() {
    // this.showLibrarySelector()
    this.fetchHdCookieData();
    // this.getantoMenu()
    // this.generatePreviewList()

  },
  mounted() {
    console.log("111111111111111111111111");

    // setTimeout(() => {
    //   this.getantoMenu()
    // }, 3000);

    // console.log(this.ddname);

  },
  computed: {

    selectedLibrarys() {
      return this.$store.state.selectedLibrary;
    },
    computedcookile() {
      return this.$store.state.cookile;
    },

    secondaryMenus() {
      return this.libraries.filter(item => item.parentId === null)
    }
  },
  watch: {
    library: {

      handler(newVal) {
        console.log(11111111111118888888888888888888888888);
        console.log(newVal);
        if (newVal && Object.keys(newVal).length) {
          console.log("子组件接收到新的 selectedLibrary:", newVal);
        }
      },
      immediate: true // 如果组件加载时也想执行一次
    },
    selectedLibrary(newVal, oldVal) {
      console.log(newVal);
      this.getantoMenu(computedcookile)
    }
  },
  methods: {
    //   generatePreviewList() {

    // },

    // 点击卡片时的处理
    // handlePreview(item) {
    //   // 确保预览列表是最新的
    //   this.generatePreviewList()

    //   // 手动触发预览（如果需要）
    //   const index = this.materialList.findIndex(i => i.filePath === item.filePath)
    //   this.$nextTick(() => {
    //     document.querySelectorAll('.el-image__preview')[index]?.click()
    //   })
    // },
    cheachallimg() {
      console.log(this.checkAllimg);
      if (this.checkAllimg) {
        // console.log(this.VmaterialList);
        this.materialList = this.materialList.map(item => {
          return { ...item, checked: true };
        });
        this.selectedMaterials = [...this.materialList]
      } else {
        this.materialList = this.materialList.map(item => {
          return { ...item, checked: false };
        });
        this.selectedMaterials = []
      }
    },
    cheachallvideo() {
      console.log(this.checkAllvideo);
      if (this.checkAllvideo) {
        console.log(this.VmaterialList);
        this.VmaterialList = this.VmaterialList.map(item => {
          return { ...item, checked: true };
        });
        this.VselectedMaterials = [...this.VmaterialList]
      } else {

        this.VmaterialList = this.VmaterialList.map(item => {
          return { ...item, checked: false };
        });
        this.VselectedMaterials = []
      }
    },
    getantoMenu(cookies) {

      console.log(this.selectedLibrarys);

      let id = this.selectedLibrarys.scId;
      this.selectedLibrary = this.selectedLibrarys;
      // this.selectedLibrary.scId
      console.log(this.$store.state);
      console.log(id);
      // let cookies = this.$store.state.cookie;
      // console.log(this.$store.state.selectedLibrary);
      // console.log(this.$store.state.cookie);
      this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
        cookie: cookies + ";b_marketing_subid=" + id,

      }).then(res => {

        console.log(res)
        // const newLibrary = {
        //   id: res.data.id,
        //   name: res.data.name,
        //   folders: []
        // }
        console.log(res.data.data.folders);
        if (res.data.data.folders.length > 0) {
          this.libraries = res.data.data.folders

        } else {
          this.libraries = [
            {
              "id": 1,
              "parentId": null,
              "name": "请先创建文件夹"
            }
          ]
        }
        this.secondaryMenus()
        this.materialList = []
        this.VmaterialList = []
        // this.fetchFolders(newLibrary.id)
        this.libraryDialogVisible = false
      })
    },

    // 删除图片
    async deleteImg() {
      // 1. 检查是否选中素材
      if (!this.selectedMaterials || this.selectedMaterials.length === 0) {
        this.$message.warning("请先选择至少一个图片素材");
        return;
      }

      try {
        // 2. 添加确认对话框
        const confirmResult = await this.$confirm(
          '确定要删除选中的 ' + this.selectedMaterials.length + ' 个素材吗？',
          '删除确认',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(function (err) { return err; });

        // 3. 处理取消操作
        if (confirmResult !== 'confirm') {
          this.$message.info('已取消删除操作');
          return;
        }

        // 4. 处理参数
        var keyCodes = this.selectedMaterials
          .filter(function (item) {
            return item && typeof item === 'object' && item.code;
          })
          .map(function (item) {
            return encodeURIComponent(item.code); // 编码特殊字符
          })
          .join(',');

        if (!keyCodes) {
          this.$message.error('无效的素材编码');
          return;
        }

        // 5. 构建请求参数
        var params = {
          params: {
            cookie: this.zjcookie + ";b_marketing_subid=" + (
              this.selectedLibrary && this.selectedLibrary.scId
                ? this.selectedLibrary.scId
                : ''
            ),
            codes: keyCodes,
            _t: Date.now() // 防止缓存
          }
        };

        // 6. 发送GET请求
        var res = await this.$axios.get(
          'https://control.zjwec.cn/api/vivo/delByCode',
          params
        );

        // 7. 处理响应（同POST版本）
        if (res.data && res.data.retcode === 0) {

          this.$message.success('成功删除 ');
          this.selectedMaterials = [];
          await this.fetchMaterials();
        } else {
          var errorMsg = res.data && res.data.message
            ? res.data.message
            : '删除操作失败';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error('删除操作异常:', error);
        this.$message.error('删除过程中发生错误，请检查控制台');
      }
    },
    async deleteVideo() {
      // 1. 检查是否选中素材

      if (!this.VselectedMaterials || this.VselectedMaterials.length === 0) {
        this.$message.warning("请先选择至少一个视频素材");
        return;
      }

      try {
        // 2. 添加确认对话框
        const confirmResult = await this.$confirm(
          '确定要删除选中的 ' + this.VselectedMaterials.length + ' 个素材吗？',
          '删除确认',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(function (err) { return err; });

        // 3. 处理取消操作
        if (confirmResult !== 'confirm') {
          this.$message.info('已取消删除操作');
          return;
        }

        // 4. 处理参数
        var keyCodes = this.VselectedMaterials
          .filter(function (item) {
            return item && typeof item === 'object' && item.code;
          })
          .map(function (item) {
            return encodeURIComponent(item.code); // 编码特殊字符
          })
          .join(',');

        if (!keyCodes) {
          this.$message.error('无效的素材编码');
          return;
        }

        // 5. 构建请求参数
        var params = {
          params: {
            cookie: this.zjcookie + ";b_marketing_subid=" + (
              this.selectedLibrary && this.selectedLibrary.scId
                ? this.selectedLibrary.scId
                : ''
            ),
            codes: keyCodes,
            _t: Date.now() // 防止缓存
          }
        };

        // 6. 发送GET请求
        var res = await this.$axios.get(
          'https://control.zjwec.cn/api/vivo/delVideoByCode',
          params
        );

        // 7. 处理响应（同POST版本）
        if (res.data && res.data.retcode === 0) {

          this.$message.success('成功删除 ');
          this.VselectedMaterials = [];
          await this.fetchMaterialsVideo();
        } else {
          var errorMsg = res.data && res.data.message
            ? res.data.message
            : '删除操作失败';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error('删除操作异常:', error);
        this.$message.error('删除过程中发生错误，请检查控制台');
      }
    },

    selectVideo() {
      this.pageIndex = 1
      this.fetchMaterialsVideo();
    },
    selectImg() {
      this.pageIndex = 1
      this.fetchMaterials()
    },

    // -----处理目录点击-------

    // 处理三级目录点击
    handleItemClick(child, parentId) {
      // 标记需要保持父级展开
      this.forceKeepOpen = true

      // 执行原有点击逻辑
      this.handleFolderClick(child)

      // 手动维护展开状态
      const parentIndex = `sec_${parentId}`
      if (!this.openedMenus.includes(parentIndex)) {
        this.openedMenus = [...this.openedMenus, parentIndex]
      }

      // 强制更新菜单状态
      this.$nextTick(() => {
        this.$refs.menuContainer.open(this.openedMenus)
        this.forceKeepOpen = false
      })
    },

    // 处理菜单选择（关键修改）
    handleMenuSelect(index, indexPath) {
      if (!this.forceKeepOpen) {
        this.openedMenus = indexPath
      }
    },

    // 其他方法保持不变...
    isSubmenuOpen(id) {
      return this.openedMenus.includes(`sec_${id}`)
    },
    toggleSubmenu(id) {
      const index = `sec_${id}`
      this.openedMenus = this.openedMenus.includes(index)
        ? this.openedMenus.filter(i => i !== index)
        : [...this.openedMenus, index]
    },
    getChildren(parentId) {
      return this.libraries.filter(item => item.parentId === parentId)
    },


    // --------------
    resetStatu() {
      this.materialList = this.materialList.map(item => ({
        ...item,
        checked: false // 强制初始化选中状态
      }));
      this.VmaterialList = this.VmaterialList.map(item => ({
        ...item,
        checked: false // 强制初始化选中状态
      }));
      this.selectedMaterials = []
      this.VselectedMaterials = []
    },
    handleAllSelect() {

      const data = {
        img: this.selectedMaterials,
        video: this.VselectedMaterials,
        sucaiku: this.selectedLibrary
      }
      this.resetStatu()
      console.log("上传所有返回的数据。。。。。。。。。。。。。。。。。。。。。。。。。。。。。");
      console.log(data);
      bus.$emit('data-selected', data);
      this.checkAllimg = false
      this.checkAllvideo = false
      this.close();


    },
    // 格式化视频时长（毫秒转 mm:ss）
    formatDuration(ms) {
      const seconds = Math.floor(ms / 1000)
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
    },

    // 格式化时间（显示为 YYYY-MM-DD）
    formatTime(dateString) {
      return dateString ? dateString.split(' ')[0] : '-'
    },
    imgReset() {
      this.imgList = []
    },
    videoReset() {
      this.videoList = []
    },
    handleFileChange(file, imgList) {
      const MAX_SIZE = 100 * 1024; // 100KB1

      // 如果当前上传的文件超过限制
      // if (file.raw && file.raw.size > MAX_SIZE) {
      //   this.$message.warning(`文件 "${file.name}" 超过了 100KB 大小限制`);

      //   // 手动从 imgList 中移除该文件
      //   this.imgList = imgList.filter(f => f.uid !== file.uid);
      //   return;
      // }
      console.log(imgList)
      this.imgList = imgList.filter(f => f.status !== 'removed')
    },
    videohandleFileChange(file, videoList) {
      const MAX_VIDEO_SIZE = 51200 * 1024; // 51200KB = 50MB

      // 判断当前上传的视频是否超过大小限制
      // if (file.raw && file.raw.size > MAX_VIDEO_SIZE) {
      //   this.$message.warning(`视频 "${file.name}" 超过了 50MB 大小限制`);

      //   // 手动移除该视频文件
      //   this.videoList = videoList.filter(f => f.uid !== file.uid);
      //   return;
      // }
      console.log(videoList)
      this.videoList = videoList.filter(f => f.status !== 'removed')
    },
    // 确认上传
    async handleConfirmUpload() {
      if (this.imgList.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }

      try {
        this.uploading = true;
        const successCodes = [];
        const failedFiles = [];

        // 第一阶段：上传所有文件
        for (let i = 0; i < this.imgList.length; i++) {
          const img = this.imgList[i];
          try {
            this.$message.info("正在上传第 " + (i + 1) + "/" + this.imgList.length + " 个文件...");

            // 执行文件上传
            const fileCode = await this.uploadFile(img);
            await this.bindMaterial(fileCode);
            successCodes.push(fileCode);

            this.$message.success("文件 " + (i + 1) + " 上传成功");
          } catch (uploadError) {
            console.error("文件 " + (i + 1) + " 上传失败:", uploadError);
            failedFiles.push(i + 1);
            const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
            this.$message.error("文件 " + (i + 1) + " 上传失败: " + errorMessage);
          }
        }

        // 第二阶段：统一绑定
        if (successCodes.length > 0) {
          try {
            this.$message.info("开始绑定 " + successCodes.length + " 个素材...");
            const codeString = successCodes.join(',');

            // 执行批量绑定
            // await this.bindMaterial(codeString);

            this.$message.success("成功绑定 " + successCodes.length + " 个素材");
          } catch (bindError) {
            console.error('批量绑定失败:', bindError);
            const bindErrMsg = bindError.message ? bindError.message.slice(0, 50) : '请联系管理员';
            this.$message.error("素材上传成功但绑定失败: " + bindErrMsg);

          }
        }

        // 第三阶段：最终处理
        if (failedFiles.length > 0) {
          this.$message.warning("完成处理，成功 " + successCodes.length + " 个，失败 " + failedFiles.length + " 个");
        }

        this.refreshMaterialData();
        this.resetUploadState();
      } catch (error) {
        console.error('流程异常:', error);
        const errMsg = error.message ? error.message.slice(0, 50) : '未知错误';
        this.$message.error("操作中断: " + errMsg);
      } finally {
        this.uploading = false;
      }
    },

    // 上传文件方法
    uploadFile(img) {
      const params = {
        access_token: this.selectedLibrary.scToken,
        advertiser_id: this.selectedLibrary.scId,
        timestamp: Date.now(),
        nonce: Math.round(Math.random() * 1e11)
      };

      var formData = new FormData();
      formData.append('file', img.raw);

      return axios.post(
        'api/openapi/v1/upload/file/image?' + Object.keys(params)
          .map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
          }).join('&'),
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(function (res) {
        return res.data.data.fileCode;
      });
    },

    // 绑定素材方法
    bindMaterial(codeString) {
      return this.$axios.post('https://control.zjwec.cn/api/sucaiku/bindFold', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        imgCode: codeString,
        folderId: this.activeFolder.id,
        type: 1
      }, {
        timeout: 15000,
        validateStatus: function (status) { return status === 200; }
      });
    },

    // 刷新数据方法
    refreshMaterialData() {

      this.fetchMaterials()
      this.fetchMaterialsVideo()

    },

    // 重置状态方法
    resetUploadState() {
      this.imgList = [];
      this.uploadDialogVisible = false;
    },

    async videohandleConfirmUpload() {
      if (this.videoList.length === 0) {
        this.$message.warning('请先选择要上传的视频文件');
        return;
      }

      try {
        this.videouploading = true;
        const successCodes = [];
        const failedFiles = [];

        // 第一阶段：上传所有视频
        for (let i = 0; i < this.videoList.length; i++) {
          const video = this.videoList[i];
          try {
            this.$message.info("正在上传第 " + (i + 1) + "/" + this.videoList.length + " 个视频...");

            // 执行视频上传
            const fileCode = await this.uploadVideoFile(video);
            await this.bindVideoMaterial(fileCode);
            successCodes.push(fileCode);

            this.$message.success("视频 " + (i + 1) + " 上传成功");
          } catch (uploadError) {
            console.error("视频 " + (i + 1) + " 上传失败:", uploadError);
            failedFiles.push(i + 1);
            const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
            this.$message.error("视频 " + (i + 1) + " 上传失败: " + errorMessage);
          }
        }

        // 第二阶段：统一绑定
        if (successCodes.length > 0) {
          try {
            this.$message.info("开始绑定 " + successCodes.length + " 个视频素材...");
            const codeString = successCodes.join(',');

            // 执行批量绑定
            // await this.bindVideoMaterial(codeString);

            this.$message.success("成功绑定 " + successCodes.length + " 个视频素材");
          } catch (bindError) {
            console.error('视频批量绑定失败:', bindError);
            const bindErrMsg = bindError.message ? bindError.message.slice(0, 50) : '请联系管理员';
            this.$message.error("视频上传成功但绑定失败: " + bindErrMsg);

          }
        }

        // 第三阶段：最终处理
        if (failedFiles.length > 0) {
          this.$message.warning("视频处理完成，成功 " + successCodes.length + " 个，失败 " + failedFiles.length + " 个");
        }

        await this.refreshVideoMaterialData();
        this.resetVideoUploadState();
      } catch (error) {
        console.error('视频流程异常:', error);
        const errMsg = error.message ? error.message.slice(0, 50) : '未知错误';
        this.$message.error("视频操作中断: " + errMsg);
      } finally {
        this.videouploading = false;
      }
    },

    // 视频上传方法
    uploadVideoFile(video) {
      const params = {
        access_token: this.selectedLibrary.scToken,
        advertiser_id: this.selectedLibrary.scId,
        timestamp: Date.now(),
        nonce: Math.round(Math.random() * 1e11)
      };

      const formData = new FormData();
      formData.append('file', video.raw);

      return axios.post(
        'api/openapi/v1/upload/file/video?' + Object.keys(params)
          .map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
          }).join('&'),
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(function (res) {
        return res.data.data.fileCode;
      });
    },

    // 视频绑定方法
    bindVideoMaterial(codeString) {
      return this.$axios.post('https://control.zjwec.cn/api/sucaiku/bindFold', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        imgCode: codeString,
        folderId: this.activeFolder.id,
        type: 2  // 注意这里类型改为2表示视频
      }, {
        timeout: 20000,  // 视频绑定超时延长到20秒
        validateStatus: function (status) { return status === 200; }
      });
    },

    // 视频数据刷新
    async refreshVideoMaterialData() {
      try {
        await this.fetchMaterials();
        await this.fetchMaterialsVideo();
      } catch (e) {
        console.error('视频数据刷新失败:', e);
      }
    },

    // 视频上传状态重置
    resetVideoUploadState() {
      this.videoList = [];
      this.videouploadDialogVisible = false;
    },

    wjjhandleAddClick(item) {

      this.beSelectFold = item
      this.wjjdialogVisible = true
    },
    async wjjhandleConfirm() {
      if (!this.newLibraryName.trim()) {
        this.$message.error('名称不能为空')
        return
      }

      this.submitting = true
      try {
        const addFoldData =
        {
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          name: this.newLibraryName,
        }
        addFoldData.parentId = this.beSelectFold != null ? this.beSelectFold.id : null;
        const res = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/addFold', addFoldData)
        console.log("添加文件夹的返回：")
        console.log(res)
        this.getFolder();
        this.$message.success('创建成功')
        this.wjjdialogVisible = false
        this.newLibraryName = ''


      } catch (error) {
        this.$message.error(`创建失败: ${error.message}`)
      } finally {
        this.submitting = false
      }
    },
    async fetchHdCookieData() {
      console.log(this.selectedLibrary);
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        // this.$store.commit('updateselectedLibrary', response.data.data.records[0].hdcookie);
        this.fjcookie = response.data.data.records[1].hdcookie
        // this.getantoMenu(response.data.data.records[0].hdcookie)
        // console.log(response.data.data.records[0].hdcookie);
        this.$store.state.cookile = response.data.data.records[0].hdcookie
        this.$store.commit('updatescookile', response.data.data.records[0].hdcookie);
        this.getantoMenu(response.data.data.records[0].hdcookie)

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    // 显示素材库选择对话框
    showLibrarySelector() {
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/getAll').then(res => {
        this.libraryOptions = res.data
        this.libraryDialogVisible = true
      })
    },

    // 确认查询文件夹
    getFolder() {
      // console.log( this.selectedLibrary)
      this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,

      }).then(res => {

        console.log(res)
        // const newLibrary = {
        //   id: res.data.id,
        //   name: res.data.name,
        //   folders: []
        // }
        if (res.data.data.folders.length > 0) {
          this.libraries = res.data.data.folders
        } else {
          this.libraries = [
            {
              "id": 1,
              "parentId": null,
              "name": "请先创建文件夹"
            }
          ]
        }

        this.materialList = []
        this.VmaterialList = []
        // this.fetchFolders(newLibrary.id)
        this.libraryDialogVisible = false
      })
    },

    // 获取文件夹列表
    fetchFolders(libraryId) {
      this.$axios.get(`/api/folders?libraryId=${libraryId}`).then(res => {
        const library = this.libraries.find(l => l.id === libraryId)
        if (library) library.folders = res.data
      })
    },

    // 处理文件夹点击
    handleFolderClick(folder) {
      this.activeFolder = folder
      this.pageIndex = 1
      this.pageSize = 52
      this.fetchMaterials()
      this.fetchMaterialsVideo()
    },


    // 分页事件处理
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchMaterials()
    },
    handlePageChange(newPage) {
      this.pageIndex = newPage
      this.fetchMaterials()
    },
    // 分页事件处理
    videohandleSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchMaterialsVideo()
    },
    videohandlePageChange(newPage) {
      this.pageIndex = newPage
      this.fetchMaterialsVideo()
    },
    // 获取素材列表
    fetchMaterials() {
      console.log("activeFolder11111111111111111111111111111111111111111111111111111111111111");
      console.log(this.activeFolder);
      if (!this.activeFolder) return

      console.log(this.activeFolder)
      this.loading = true
      // 修改请求方式为GET
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/selectFold', {
        params: {
          folderId: this.activeFolder.id,
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          SearchKey: this.ImgSCName
        }
      }).then(res => {
        // 适配新的响应结构
        // 降序排序（Z-A）
        this.materialList = res.data.data.list.slice().sort(function (a, b) {
          // 处理空值情况
          var titleA = a.title || '';
          var titleB = b.title || '';
          // 中文排序
          return titleB.localeCompare(titleA, 'zh-Hans-CN');
        });

        this.totalCount = res.data.data.total;
      }).finally(() => {
        this.loading = false
      })
    },

    fetchMaterialsVideo() {
      if (!this.activeFolder) return

      this.loading = true
      // 修改请求方式为GET
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/selectFoldVideo', {
        params: {
          folderId: this.activeFolder.id,
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          SearchKey: this.VideoSCName
        }
      }).then(res => {
        // 适配新的响应结构
        // this.VmaterialList = res.data.data.list;
        this.VmaterialList = res.data.data.list.slice().sort(function (a, b) {
          // 处理空值情况
          const titleA = a.title || '';
          const titleB = b.title || '';
          // 中文排序
          return titleB.localeCompare(titleA, 'zh-Hans-CN');
        });
        this.videototalCount = res.data.data.total;
      }).finally(() => {
        this.loading = false
      })
    },

    // 处理标签切换
    handleTabChange() {
      this.pageIndex = 1
      this.pageSize = 52
      if (this.activeFolder) {
        this.fetchMaterials()
        this.fetchMaterialsVideo()
      }
    },

    // 显示上传对话框
    showUploadDialog(type) {
      if (!this.activeFolder) {
        this.$message.warning('请先选择文件夹')
        return
      }
      this.uploadType = type
      this.uploadUrl = `/api/upload/${type}?folderId=${this.activeFolder.id}`
      this.acceptType = type === 'image' ? 'image/*' : 'video/*'
      this.uploadDialogVisible = true
    },
    getImageUrl(item) {
      // console.log(item);
      var base = 'https://ads-marketing-vivofs.vivo.com.cn/'
      console.log(base + (item || '').replace(/^\//, ''));
      return base + (item || '').replace(/^\//, '')
    },

    showvideoUploadDialog() {
      if (!this.activeFolder) {
        this.$message.warning('请先选择文件夹')
        return
      }
      this.videouploadDialogVisible = true
    },
    // 处理上传成功
    handleUploadSuccess() {
      this.uploadDialogVisible = false
      this.fetchMaterials()
      this.$message.success('上传成功')
    },

    videohandleUploadSuccess() {
      this.videouploadDialogVisible = false
      this.fetchMaterialsVideo()
      this.$message.success('上传成功')
    },


    // 处理卡片选择
    handleCardSelect(item) {
      console.log(item);
      if (item.checked) {
        this.selectedMaterials.push(item)
        this.handletpCardSelect = this.selectedMaterials.length
      } else {
        this.selectedMaterials = this.selectedMaterials.filter(m => m.id !== item.id)
        this.handletpCardSelect = this.selectedMaterials.length
      }
    },
    VhandleCardSelect(item) {
      if (item.checked) {
        this.VselectedMaterials.push(item)
        this.handlespCardSelectnumber = this.VselectedMaterials.length
      } else {
        this.VselectedMaterials = this.VselectedMaterials.filter(m => m.id !== item.id)
        this.handlespCardSelectnumber = this.VselectedMaterials.length
      }
    },

    checkVideo(item) {
      console.log(item)
      if (item.checked == true) {
        item.checked = false
        this.VhandleCardSelect(item)
      } else {
        item.checked = true
        this.VhandleCardSelect(item)
      }
    },


    // 预览素材
    handlePreview(item) {
      // this.previewItem = item
      // this.previewVisible = true
      //
      let res = this.materialList.filter(items =>
        items.id == item.id
      )
      this.previewList = ['https://ads-marketing-vivofs.vivo.com.cn/' + res[0].filePath]
      console.log(res);
      console.log(this.previewList);
      // this.generatePreviewList()
      if (item.checked == true) {
        item.checked = false
        this.handleCardSelect(item)
      } else {
        item.checked = true
        this.handleCardSelect(item)
      }

    },
    VhandlePreview(item) {
      console.log(item);
      this.VpreviewVisible = false // 先关闭再打开
      this.$nextTick(() => {
        this.VpreviewItem = { ...item } // 创建新对象触发响应式
        this.VpreviewVisible = true
      })
    },
    tpVhandlePreview(item) {
      this.VpreviewVisible = false // 先关闭再打开
      this.$nextTick(() => {
        this.VpreviewItem = { ...item } // 创建新对象触发响应式
        this.VpreviewVisible = true
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  height: 100vh;
}

.library-selector {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
}

.library-menu {
  border-right: none;
}

.action-bar {
  margin-bottom: 15px;
}

.material-container {
  min-height: 500px;
}

.material-card {
  margin-bottom: 20px;
  position: relative;
  transition: all 0.3s;
}

.material-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.card-checkbox {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
}

.card-content {
  cursor: pointer;
}

.card-image {
  width: 100%;
  height: 180px;
  border-radius: 4px;
}

.image-error {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.image-error i {
  font-size: 40px;
  color: #909399;
}

.card-info {
  padding: 10px 0;
}

.file-name {
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size,
.file-time {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ebeef5;
  padding-top: 10px;
}

.video-wrapper {
  position: relative;
}

.video-duration {
  position: absolute;
  right: 5px;
  bottom: 5px;
  background: rgba(0, 0, 0, .5);
  color: #fff;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 12px;
}

.video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  color: rgba(255, 255, 255, .8);
  text-shadow: 0 2px 4px rgba(0, 0, 0, .3);
}

.preview-image {
  max-height: 80vh;
  object-fit: contain;
}

.upload-wrapper {
  text-align: center;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}
</style>
<style scoped>
.container {
  /* 示例自适应布局 */
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-area {
  flex: 1;
  overflow: auto;
  padding: 20px;
}

.control-bar {
  height: 60px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
<style>
/* 隐藏默认箭头 */
.el-submenu__icon-arrow {
  display: none !important;
}

/* 自定义布局 */
.submenu-header {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 20px;
}

.expand-icon {
  padding: 0 8px;
  cursor: pointer;
  transition: transform 0.3s;
}

.title-content {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.el-icon-circle-plus {
  margin-left: auto;
  padding: 0 10px;
  color: #909399;
  transition: all 0.3s;
}

.el-icon-circle-plus:hover {
  color: #409EFF;
}
</style>
<style>
/* 新增CSS */
.compact-row {
  /* 解决 flex 换行问题 */
  flex-wrap: wrap;
  /* 替代 gutter 的间距方案 */
  margin: -6px !important;
  /* 补偿列间距 */
}

.el-col {
  /* 关键：强制列间距为12px */
  padding: 6px !important;
}

.col-inner {
  /* 保证卡片高度统一 */
  height: 100%;
}

.material-card {
  /* 确保卡片填满列容器 */
  height: 100%;
  /* 防止内容溢出 */
  box-sizing: border-box;
  /* 微调视觉效果 */
  transition: 0.3s;
}

/* 修复 Element 默认样式冲突 */
.el-card__body {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-content {
  flex: 1;
  /* 内容区域自动填充剩余高度 */
}

/*@media (max-width: 1200px) {*/
/*  .el-col.lg-6 {*/
/*    min-width: calc(25% - 12px); !* 强制4列布局 *!*/
/*  }*/
/*}*/

/*@media (max-width: 992px) {*/
/*  .el-col.md-8 {*/
/*    min-width: calc(33.33% - 12px); !* 强制3列布局 *!*/
/*  }*/
/*}*/

/* 新增精准控制CSS（不影响原有样式） */
.video-row {
  margin: 0 -8px !important;
  /* 补偿间距 */
}

.el-col {
  padding: 0 8px !important;
  /* 列间距 */
  margin-bottom: 16px !important;
  /* 行间距 */
}

.video-card-wrapper {
  height: 100%;
  min-width: 0;
  /* 关键：解决flex溢出 */
}

.material-card {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/sucaiku.vue